import React, { useContext } from "react";
import { AssociateContext } from "./context/AssociateContext";
import Row from "@amzn/meridian/row";
import Breadcrumb, { BreadcrumbGroup } from "@amzn/meridian/breadcrumb";
import { FormattedMessage } from "react-intl";
import AssociateDetail from "./AssociateDetail";
import { RESET_ASSOCIATE_SELECTION } from "../RouteStatus/utils/ReducerActionTypes";
import {
  ASSOCIATE_DETAILS,
  ROUTE_DETAILS,
} from "../RouteStatus/utils/Constants";

const AssociateDetailView = () => {
  const { associateViewModel, associateModelDispatcher } =
    useContext(AssociateContext);
  const resetAssociateSelection = () => {
    associateModelDispatcher({ type: RESET_ASSOCIATE_SELECTION });
  };

  return (
    <div>
      <Row widths="100%" spacingInset="large large small">
        <BreadcrumbGroup>
          <Breadcrumb onClick={() => resetAssociateSelection()}>
            <FormattedMessage
              id="routeInfo.routestatus"
              defaultMessage={ROUTE_DETAILS}
            />
          </Breadcrumb>
          <Breadcrumb>
            <FormattedMessage
              id="associate.associate_detail"
              defaultMessage={ASSOCIATE_DETAILS}
            />
          </Breadcrumb>
        </BreadcrumbGroup>
      </Row>
      {associateViewModel.associate.map((associate) => (
        <AssociateDetail key={associate} associate={associate} />
      ))}
    </div>
  );
};
export default AssociateDetailView;



// WEBPACK FOOTER //
// ./src/components/associate/AssociateDetailView.js